<div style="border:thin solid lightblue">
    <label [style.display]="errorMsg?'inline':'none'" style="color:red">{{errorMsg}}</label>
    <label>
        My fire 
        <svg width="24" height="24" viewBox="0 0 24 24" style.stroke="{{color}}" style="fill: none;">
            <path d="M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"></path>
        </svg> works!
    </label>
    <div class="myform">

        <form novalidate [formGroup]="myform">
            Valid:{{myform.valid}}
            <div>
                <div>Name: </div>
                <input type="text"  [ngClass]="{'validation-error': myName.invalid}"
                [title] = "myName.invalid ? 'required' : ''"   [formControl]="myName"  />
            </div>
            <div *ngIf="myJavaExperience as cc" >
                
                <div>Java Experience:</div>
                <input type="text" [formControl]="cc"
                [ngClass]="cc.getErrorClass()"
                [title]="cc.getError()"
                  />
            </div>
            <div >
                <div>Salary:</div>
                <input type="text" [formControl]="mySalary2"
                [ngClass]="mySalary2.getErrorClass()"
                [title]="mySalary2.getError()"
                  />
            </div>

            <div *ngIf="rangeStart as cc" >                
                <div>Range start:</div>
                <input type="text" [formControl]="cc"
                [ngClass]="cc.getErrorClass()"
                [title]="cc.getError()"
                  />
            </div>
            <div *ngIf="rangeEnd as cc" >                
                <div>Range end:</div>
                <input type="text" [formControl]="cc"
                [ngClass]="cc.getErrorClass()"
                [title]="cc.getError()"
                  />
            </div>
            <div>
                <button (click) = "changeSalary()" >change salary</button>
            </div>
            
        </form>
    </div>
</div>